export default "static/dist/img/outline-error_outline-24px.svg?38f78c492ac60ee4488399b7b2345d63";